export default{
    "common":{
        "btnPrimary":"确 认",
        "btnUsual":"取 消",
        "btnSearch":"查询"
    },
    "header":{
        "nav":"功能列表",
        "who":"接口返回",
        "uimenu" : {
            "userInfo":"修改密码",
            "loggingstatus":"退出登录",
            "version":"系统版本",
            "typetheme":"主题切换",
            "skintitle":"更换皮肤",
        },
        "gSearch":{
            "label1":"结算表",
            "label2":"考核表",
            "placeholder1":"用户名称、用户编号检索",
            "placeholder2":"仪表名称、仪表编号检索"
        },
        "theme1":"素雅白",
        "theme2":"暗夜黑"
    },
    "bookmarks":{
        "usual":"常用功能",
        "stableName":'控制台',
        "collectTip1":"添加",
        "collectTip2":"取消"
    },
    "featurelist":{
        "placeholder":"请输入名称、缩写...",
        "tip1":"收藏成功。",
        "tip2":"收藏失败。",
        "tip3":"取消收藏成功。",
        "tip4":"取消收藏失败。"
    },
    "devops":{
        "customer":"客户名称：",
        "title":"请选择本次所要运维的客户",
        "placeholder":"请输入搜索内容",
        "label":"最近访问：",
        "result":"未搜到匹配数据"
    },
    "searchdialog":{
        "title":"高级查询"
    },
    "personal":{
        "title":"个人信息",
        "name":"用户名称：",
        "inp1":"旧密码：",
        "inp2":"新密码：",
        "inp3":"确认密码：",
        "pl1":"输入旧密码",
        "pl2":"输入新密码",
        "pl3":"输入确认密码",
        "valid":"请输入6至16位字母与数字组合密码"
    },
    "leftTree":{
        "dropdown1":"刷新",
        "dropdown2":"全部展开",
        "dropdown3":"全部折叠",
        "placeholder":"请输入检索内容"
    },
    "alarmDialog":{
        "title":"告警信息",
        "nosource":"无数据",
        "more":"更多",
        "detail":"详情"
    },
    "guidemask":{
        "step1":"滑动此处可展开所有功能并能点击收藏",
        "step2":"滑动此处可展开收藏列表点击导航切换",
        "step3":"点击此处可固定导航方便功能查看",
        "step4":"滑动此处可展开个人信息列表选择换肤",
        "back":"上一步",
        "next":"下一步",
        "close":"我知道了"
    },
    "gdmap":{
        "addr":"地址：",
        "lgd":"经度：",
        "ltd":"纬度：",
        "pla":"请输入地点信息"
    }
}